<template>
  <div :class="groupClass">
    <label :class="lableClass" :for="name">
      <slot>{{ title }}</slot>
    </label>

    <div :class="fieldClass">
      <div :class="inputGroupClass">
        <!--Special Part Starts-->
        <div v-if="$lodash.has($slots, 'prepend')" class="input-group-prepend">
          <slot name="prepend"></slot>
        </div>
        <input
          :id="actualId"
          :autocomplete="autocomplete"
          :class="{ 'is-invalid': form && form.errors.has(errorId) }"
          :disabled="isDisabled"
          :name="nameAttribute"
          :placeholder="placeholder"
          :readonly="isReadonly"
          :required="isRequired"
          :value="value"
          class="form-control"
          type="password"
          @input="update($event.target.value)"
          @keydown="keydown($event)"
        />
        <div v-if="$lodash.has($slots, 'append')" class="input-group-append">
          <slot name="append"></slot>
        </div>
        <!--Special Part Ends-->
      </div>

      <div
        v-if="form && form.errors.has(errorId)"
        class="invalid-feedback"
        v-text="form.errors.get(errorId)"
      ></div>
      <slot name="note"></slot>
    </div>

    <div :class="extraSlotClass">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,

  computed: {
    nameAttribute() {
      return this.autocomplete ? this.name : `${this.name}-${window.generateUUID()}`;
    },
  },

  methods: {
    update(value) {
      this.$emit("input", value);
    },

    keydown(event) {
      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$emit("keydown", event);
    },
  },
};
</script>
